import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

import { Cidade } from './cidades'

const FeriadosClienteSchema = zod.FeriadosClienteSchema.omit({
    cidadeId: true,
    id: true,
    createdAt: true,
    updatedAt: true,
}).extend({
    cidade: z.string(),
    ibge: z.number(),
})

type FeriadosClienteInput = z.infer<typeof FeriadosClienteSchema>
export type FeriadosCliente = z.infer<typeof zod.FeriadosClienteSchema> & {
    Cidade: Cidade
}

export const createFeriadoSchema = zod.FeriadosClienteSchema.omit({
    id: true,
    clienteId: true,
    cidadeId: true,
    dia: true,
    mes: true,
    ano: true,
    createdAt: true,
    updatedAt: true,
}).extend({
    Cidade: z.object(
        {
            ibge: z.number(),
            cidade: z.string(),
        },
        {
            invalid_type_error: 'Selecione uma cidade',
        },
    ),
    data: z.coerce.date(),
    repetir: z.boolean(),
})

export type CreateFeriadoInput = z.infer<typeof createFeriadoSchema>

const service = new ApiService<FeriadosClienteInput, FeriadosCliente>(
    'feriados-clientes',
)

const funcionario = new ApiService<
    FeriadosCliente,
    FeriadosCliente,
    { funcionarioId: number; ano: number }
>('feriados-clientes/funcionario')

export const feriadosCliente = Object.assign(service, { funcionario })
